var React = require('react');

function Scalpel (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M176 320h105.6v8c0 38.39-15.35 76.61-46.72 102.32l-.59.48C170.28 482.82 87 512.07 0 512z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M199.9 288a16 16 0 0 1-12.19-26.47l201.5-235.46C412.52-1.18 453.5-9 482.7 11.85c33.76 24.08 38.9 71.69 12.53 102.49l-139 162.44A32.08 32.08 0 0 1 331.84 288z","className":"fa-primary","key":2})]);
}

Scalpel.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Scalpel;

Scalpel.default = Scalpel;
